/*
 * @Desc:全局组件注册
 * @Version: v1.00
 * @Author: went
 * @Date: 2021-08-26 11:08:11
 * @LastEditors: hf
 * @LastEditTime: 2022-02-11 10:30:59
 */
import svgIcon from "@components/common/svgIcon.vue";
export default function (Vue) {
  Vue.component("svgIcon", svgIcon);
}
